import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const SolicitudProcesarArchivo = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/SolicitudProcesarArchivo",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { SolicitudProcesarArchivo };
